import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PersonalizationContext = /*#__PURE__*/createContext({
  openPanel: () => {
    throw new Error('PersonalizationContext not initialized\nPlease use PersonalizationWrapper to wrap your component');
  },
  isPanelOpen: false
});
export const PersonalizationContextProvider = ({
  openPanel,
  isPanelOpen,
  children
}) => /*#__PURE__*/_jsx(PersonalizationContext.Provider, {
  value: {
    openPanel,
    isPanelOpen
  },
  children: children
});
export const usePersonalizationContext = () => useContext(PersonalizationContext);